import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Profiles Redux States
import {
  GET_PROFILES_BACKOFFICE,
  GET_PROFILES_CLIENT,
  GET_PROFILE,
  CREATE_PROFILE,
  DELETE_PROFILE,
  EDIT_PROFILE,
} from "./actionTypes";
import {
  setProfiles,
  apiError,
  setProfile,
  createProfileSuccess,
  editProfileSuccess,
  deleteProfileSuccess,
} from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getProfilesBackoffice({
  payload: { page, qnt, name, description, isForm },
}) {
  try {
    const response = yield call(
      axios.get,
      `/profile?${
        (page ? `&page=${page}` : "") +
        (qnt ? `&qtd=${qnt}` : "") +
        (name ? `&name=${name}` : "") +
        (description ? `&description=${description}` : "") +
        (isForm ? `&form=${isForm}` : "")
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setProfiles(response.data.data, qnt));
    } else throw response.data;
  } catch (error) {
    let message = error.message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* getProfilesClient({
  payload: { idCompany, page, qnt, name, description, isForm },
}) {
  try {
    const response = yield call(
      axios.get,
      `/client/profile?${
        (idCompany ? `&client_id=${idCompany}` : "") +
        (page ? `&page=${page}` : "") +
        (qnt ? `&qtd=${qnt}` : "") +
        (name ? `&name=${name}` : "") +
        (description ? `&description=${description}` : "") +
        (isForm ? `&form=${isForm}` : "")
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setProfiles(response.data.data, qnt, idCompany));
    } else throw response.data;
  } catch (error) {
    let message = error.message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* createProfile({
  payload: { newProfileValues, idCompany, idDepartment },
}) {
  try {
    let response;
    if (idCompany) {
      response = yield call(
        axios.post,
        `/client/profile?${
          (idCompany ? `&client_id=${idCompany}` : "") +
          (idDepartment ? `&department_id=${idDepartment}` : "")
        }`,
        newProfileValues
      );
    } else {
      response = yield call(axios.post, `/profile`, newProfileValues);
    }
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.message
    ) {
      let message = response.data.message;
      yield put(createProfileSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* getProfile({ payload: { idProfile, idCompany, isForm } }) {
  try {
    let response;
    if (idCompany) {
      response = yield call(
        axios.get,
        `/client/profile?${
          (idCompany ? `&client_id=${idCompany}` : "") +
          (idProfile ? `&id=${idProfile}` : "") +
          (isForm ? `&form=${isForm}` : "")
        }`,
        {}
      );
    } else {
      response = yield call(
        axios.get,
        `/profile?${
          (idProfile ? `&id=${idProfile}` : "") +
          (isForm ? `&form=${isForm}` : "")
        }`,
        {}
      );
    }
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setProfile(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* editProfile({
  payload: { idProfile, newProfileValues, idCompany, idDepartment },
}) {
  try {
    let response;
    if (idCompany) {
      response = yield call(
        axios.patch,
        `/client/profile?${
          (idCompany ? `&client_id=${idCompany}` : "") +
          (idProfile ? `&id=${idProfile}` : "") +
          (idDepartment ? `&department_id=${idDepartment}` : "")
        }`,
        newProfileValues
      );
    } else {
      response = yield call(
        axios.patch,
        `/profile${idProfile ? `?id=${idProfile}` : ""}`,
        newProfileValues
      );
    }
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.message
    ) {
      let message = response.data.message;
      yield put(editProfileSuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* deleteProfile({ payload: { idProfile, idCompany, idDepartment } }) {
  try {
    let response;
    if (idCompany) {
      response = yield call(
        axios.delete,
        `/client/profile?${
          (idCompany ? `&client_id=${idCompany}` : "") +
          (idProfile ? `&id=${idProfile}` : "") +
          (idDepartment ? `&department_id=${idDepartment}` : "")
        }`,
        {}
      );
    } else {
      response = yield call(
        axios.delete,
        `/profile${idProfile ? `?id=${idProfile}` : ""}`,
        {}
      );
    }
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.message
    ) {
      let message = response.data.message ? response.data.message : "";
      yield put(deleteProfileSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

export function* watchProfilesBackoffice() {
  yield takeEvery(GET_PROFILES_BACKOFFICE, getProfilesBackoffice);
}
export function* watchProfilesClient() {
  yield takeEvery(GET_PROFILES_CLIENT, getProfilesClient);
}
export function* watchGetProfile() {
  yield takeEvery(GET_PROFILE, getProfile);
}
export function* watchCreateProfile() {
  yield takeEvery(CREATE_PROFILE, createProfile);
}
export function* watchEditProfile() {
  yield takeEvery(EDIT_PROFILE, editProfile);
}
export function* watchDeleteProfile() {
  yield takeEvery(DELETE_PROFILE, deleteProfile);
}
function* authSaga() {
  yield all([
    fork(watchProfilesBackoffice),
    fork(watchProfilesClient),
    fork(watchCreateProfile),
    fork(watchGetProfile),
    fork(watchEditProfile),
    fork(watchDeleteProfile),
  ]);
}

export default authSaga;
